export enum InvoiceReason {
    INVOICE_OPEN = 'INVOICE_OPEN',
    INVOICE_CLOSED = 'INVOICE_CLOSED',
    INVOICE_PAID = 'INVOICE_PAID',
    INVOICE_PAYMENT_FAILED = 'INVOICE_PAYMENT_FAILED',
    INVOICE_UNCOLLECTIBLE = 'INVOICE_UNCOLLECTIBLE',
}
